import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const EndOfTrialModalContainerWithErrorBoundaryLoadable: LoadableType<{}> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-EndOfTrialModalContainerWithErrorBoundary" */ './index.tsx'
				)
			).EndOfTrialModalContainerWithErrorBoundary,
	});
